import React, {MouseEventHandler, ReactNode} from 'react'
import {Form} from 'react-bootstrap'
import Feedback from './Feedback'
import {FormikProps} from 'formik'
import DOMPurify from 'dompurify'

type Props = {
  required?: boolean
  formik: FormikProps<any>
  label?: string
  name: string
  placeholder?: string
  min?: string | number
  max?: string | number
  maxLength?: number
  children?: ReactNode
  disabled?: boolean
  textarea?: boolean
  isInvalid?: boolean
  type?: 'text' | 'number' | 'date'
  onKeyDown?: any
  isCode?: boolean
  isName?: boolean
  isFreeText?: boolean
  isNumber?: boolean
  noCheckText?: boolean
  autoComplete?: string
}

const TextField: React.FC<Props> = ({
  required,
  formik,
  label,
  name,
  placeholder,
  min = 0,
  max = 9999999,
  maxLength = 255,
  disabled,
  textarea,
  isInvalid,
  type = 'text',
  onKeyDown,
  isCode,
  isName,
  isFreeText,
  noCheckText = false,
  isNumber,
  autoComplete = 'off',
}) => {
  const handlePaste = (event) => {
    console.log('noCheckText', noCheckText)
    // const pattern = /[`~%^&*!@#$()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi
    const pattern = /[_]/gi
    const sanitizedContent = DOMPurify.sanitize(event.clipboardData.getData('text/plain'))
    console.log('sanitizedContent', sanitizedContent)
    if (pattern.test(event.clipboardData.getData('text/plain')) && !noCheckText) {
      event.preventDefault()
    } else {
      formik.setFieldValue(formik.values.name, sanitizedContent)
    }
  }

  const handleKeyPhone = (e) => {
    if (
      !(
        (
          (e.key >= '0' && e.key <= '9') || // Numbers
          e.key === 'Backspace' || // Backspace
          e.key === 'Tab' || // Tab
          e.key === 'Enter' || // Enter
          e.key === 'ArrowLeft' || // Left Arrow
          e.key === 'ArrowRight' || // Right Arrow
          e.key === 'Delete' || // Delete
          e.key === 'Home' || // Home
          e.key === 'End'
        ) // End
      )
    ) {
      e.preventDefault() // Prevent default behavior for non-numeric keys
    }
  }
  const handleKeyDown = (event) => {
    // let pattern = /[`~%^&*!@#$()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi
    const pattern = /[_]/gi
    if (pattern.test(event.key)) {
      event.preventDefault() // Prevent default behavior for underscore key
    }
  }
  const handleName = (event) => {
    let pattern = /_/gi
    if (pattern.test(event.key)) {
      event.preventDefault() // Prevent default behavior for underscore key
    }
  }

  return (
    <>
      <Form.Group className='mb-3'>
        <Form.Label>
          {label} {required && <span className='text-danger'>*</span>}
        </Form.Label>
        {!textarea ? (
          <Form.Control
            autoComplete={autoComplete}
            onKeyDown={
              isName ? handleName : isCode ? handleKeyDown : isNumber ? handleKeyPhone : undefined
            }
            onPaste={handlePaste}
            placeholder={placeholder}
            type={type}
            {...formik.getFieldProps(`${name}`)}
            disabled={disabled || formik.isSubmitting}
            isInvalid={(formik.touched[name] && !!formik.errors[name]) || isInvalid}
            min={min}
            max={max}
            maxLength={maxLength}
          />
        ) : (
          <Form.Control
            autoComplete={autoComplete}
            onKeyDown={undefined}
            onPaste={handlePaste}
            placeholder={placeholder}
            as='textarea'
            {...formik.getFieldProps(`${name}`)}
            disabled={disabled || formik.isSubmitting}
            isInvalid={(formik.touched[name] && !!formik.errors[name]) || isInvalid}
            rows={3}
          />
        )}
        {formik.touched[name] && formik.errors[name] && (
          <Feedback>
            <>{formik.errors[name]}</>
          </Feedback>
        )}
        {isInvalid && (
          <Feedback>
            <>{label} is required.</>
          </Feedback>
        )}
      </Form.Group>
    </>
  )
}
export default TextField
